<!--================================
=            CHIPGROUPS            =
=================================-->
<template>
  <!-- WIDGETS CARDS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Chips Groups</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Playground</div>
          <div slot="card-body">
            <v-card max-width="400" class="mx-auto">
              <v-system-bar></v-system-bar>
              <v-card-title>
                <v-btn icon class="mr-6">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>

                <span class="subheading">Filter your files</span>
              </v-card-title>
              <v-card-text>
                <v-row justify="space-around">
                  <v-switch v-model="column" label="Column"></v-switch>
                  <v-switch v-model="mandatory" label="Mandatory"></v-switch>
                  <v-switch v-model="multiple" label="Multiple"></v-switch>
                </v-row>
                <span class="subheading">Filter by Tags</span>
                <v-chip-group
                  :multiple="multiple"
                  :mandatory="mandatory"
                  :column="column"
                  active-class="primary--text"
                >
                  <v-chip v-for="tag in tags" :key="tag">
                    {{ tag }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Column</div>
          <div slot="card-body">
            <v-row justify="space-around">
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-sheet elevation="10" class="pa-4">
                  <v-chip-group column active-class="primary--text">
                    <v-chip v-for="tag in tags" :key="tag">
                      {{ tag }}
                    </v-chip>
                  </v-chip-group>
                </v-sheet>
              </v-col>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Mandatory</div>
          <div slot="card-body">
            <v-row justify="space-around">
              <v-col cols="12" sm="6" md="4">
                <v-sheet elevation="10" class="py-4 px-1">
                  <v-chip-group mandatory active-class="primary--text">
                    <v-chip v-for="tag in tags" :key="tag">
                      {{ tag }}
                    </v-chip>
                  </v-chip-group>
                </v-sheet>
              </v-col>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Multiple</div>
          <div slot="card-body">
            <v-row justify="space-around">
              <v-col cols="12" sm="6" md="4">
                <v-sheet elevation="10" class="py-4 px-1">
                  <v-chip-group multiple active-class="primary--text">
                    <v-chip v-for="tag in tags" :key="tag">
                      {{ tag }}
                    </v-chip>
                  </v-chip-group>
                </v-sheet>
              </v-col>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Toothbrush card</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="400">
              <v-card-title>
                <h2 class="display-1">Toothbrush</h2>
                <v-spacer></v-spacer>
                <span class="title">$4.99</span>
              </v-card-title>

              <v-card-text>
                Our company takes pride in making handmade brushes. Our
                toothbrushes are available in 4 different bristel types, from
                extra soft to hard.
              </v-card-text>

              <v-divider class="mx-4"></v-divider>

              <v-card-text>
                <span class="subheading">Select type</span>

                <v-chip-group
                  v-model="selection"
                  active-class="deep-purple--text text--accent-4"
                  mandatory
                >
                  <v-chip>Extra Soft</v-chip>
                  <v-chip>Soft</v-chip>
                  <v-chip>Medium</v-chip>
                  <v-chip>Hard</v-chip>
                </v-chip-group>
              </v-card-text>

              <v-card-actions>
                <v-btn block class="white--text" color="deep-purple accent-4">
                  Add to Cart
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Blouse product card</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="400">
              <v-card-title>
                <h2 class="display-1">Shirt Blouse</h2>
                <v-spacer></v-spacer>
                <span class="title">$44.50</span>
              </v-card-title>

              <v-card-text>
                Our blouses are available in 8 colors. You can custom order a
                built-in arch support for any of the models.
              </v-card-text>

              <v-divider class="mx-4"></v-divider>

              <v-card-text>
                <span class="subheading">Select size</span>

                <v-chip-group
                  v-model="selection"
                  active-class="deep-purple--text text--accent-4"
                  mandatory
                >
                  <v-chip v-for="size in sizes" :key="size" :value="size">
                    {{ size }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>

              <v-card-actions>
                <v-btn block class="white--text" color="deep-purple accent-4">
                  Add to Cart
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Filter results</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="400">
              <v-toolbar flat color="deep-purple accent-4" dark>
                <v-btn icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Filter results</v-toolbar-title>
              </v-toolbar>

              <v-card-text>
                <h2 class="title mb-2">Choose amenities</h2>

                <v-chip-group v-model="amenities" column multiple>
                  <v-chip filter outlined>Elevator</v-chip>
                  <v-chip filter outlined>Washer / Dryer</v-chip>
                  <v-chip filter outlined>Fireplace</v-chip>
                  <v-chip filter outlined>Wheelchair access</v-chip>
                  <v-chip filter outlined>Dogs ok</v-chip>
                  <v-chip filter outlined>Cats ok</v-chip>
                </v-chip-group>
              </v-card-text>

              <v-card-text>
                <h2 class="title mb-2">Choose neighborhoods</h2>

                <v-chip-group v-model="neighborhoods" column multiple>
                  <v-chip filter outlined>Snowy Rock Place</v-chip>
                  <v-chip filter outlined>Honeylane Circle</v-chip>
                  <v-chip filter outlined>Donna Drive</v-chip>
                  <v-chip filter outlined>Elaine Street</v-chip>
                  <v-chip filter outlined>Court Street</v-chip>
                  <v-chip filter outlined>Kennedy Park</v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data: () => ({
    column: true,
    mandatory: false,
    selection: "08",
    multiple: true,
    amenities: [1, 4],
    neighborhoods: [1],
    sizes: ["04", "06", "08", "10", "12", "14"],
    tags: [
      "Work",
      "Home Improvement",
      "Vacation",
      "Food",
      "Drawers",
      "Shopping",
      "Art",
      "Tech",
      "Creative Writing"
    ]
  })
};
</script>

<!--====  End of CHIPGROUPS  ====-->
